export const PROJECT_GUIDE = 'Project Guide';
export const BUYING_GUIDE = 'Buying Guide';
export const INSTALLATION_SERVICES = 'Installation Services';
export const TOOL_RENTAL = 'Tool Rental';
export const FULL_CARD = 'full';
export const RENTAL_CARD = 'rental';

const INSTALL_TYPE = 'install';

export function getCardType(type) {
  switch (type) {
  case PROJECT_GUIDE:
    return 'guide';
  case BUYING_GUIDE:
    return 'guide';
  case INSTALLATION_SERVICES:
  case INSTALL_TYPE:
    return 'install';
  case TOOL_RENTAL:
    return 'rental';
  default:
    return null;
  }
}

export const transformContentServicesForModelInterpretation = (content) => {
  if (!content) return null;

  return {
    universalSearchArray: [
      {
        pods: [{
          title: content?.title,
          description: content?.description,
          imageUrl: content?.imageUrl,
          link: content?.link,
          recordType: content?.recordType,
        }],
        info: {
          title: content?.podTitle,
          type: content?.type,
        }
      }
    ],
    productTypes: []
  };

};

const filterProContentCardsForMA = (cardArray, isB2BCustomer) => {
  if (!isB2BCustomer) return cardArray;

  return cardArray.map((card) => {
    if (card?.info?.title === TOOL_RENTAL) {
      return card;
    }

    const proContentPods = (card.pods || []).filter((pod) => pod.isProContent);

    return {
      ...card,
      pods: proContentPods,
    };
  });
};

export const getCategoryCardsForMA = (data, isB2BCustomer) => {
  const unfilteredCards = data?.searchModel?.orangeGraph?.universalSearchArray;
  if (!unfilteredCards) return data;

  const filteredCards = filterProContentCardsForMA(unfilteredCards, isB2BCustomer)
    .filter((card) => card?.pods && card.pods.length > 0);

  return {
    ...data,
    searchModel: {
      ...data.searchModel,
      orangeGraph: {
        ...data.searchModel.orangeGraph,
        universalSearchArray: filteredCards,
      },
    },
  };
};